// ══════════════════════════════════════
// 8BITBRAIN v2.6
// ══════════════════════════════════════

// main.js loads at the very end of <body> (layout/theme.liquid), so the markup it wires up is already
// parsed: run now instead of waiting for DOMContentLoaded, which also waits for every deferred app script
// (the mobile menu, accordions and text effects used to stay dead on slow phones until then).
// Each block stays isolated, as separate DOMContentLoaded listeners were: an error in one is still
// reported (re-thrown async) but can no longer abort the rest of this file (menu, timers, loader hide).
function bbReady(fn) {
  function run() { try { fn(); } catch (err) { setTimeout(function() { throw err; }, 0); } }
  if (document.readyState !== 'loading' || document.getElementById('custom-scrollbar')) run();
  else document.addEventListener('DOMContentLoaded', run);
}

// ── Custom Scrollbar ──
// At most one update per frame (rAF), and the page height is measured only when the page actually
// changes size (ResizeObserver), not on every scroll event: reading scrollHeight inside a scroll handler
// forced a full layout whenever anything on the page had changed since the last frame (timers, reveals).
(function(){
  var thumb = document.getElementById('scroll-thumb');
  if (!thumb) return;
  var docH = 0, lastH = '', lastT = '', queued = 0;
  function measure() { docH = document.body ? document.body.scrollHeight : 0; }
  function update() {
    queued = 0;
    if (!docH) measure();
    var vh = window.innerHeight;
    var pct = window.scrollY / Math.max(1, docH - vh);
    var h = Math.max(vh * 0.12, 40);
    var hs = h + 'px', ts = 'translateY(' + (pct * (vh - h)) + 'px)';
    if (hs !== lastH) { lastH = hs; thumb.style.height = hs; }
    if (ts !== lastT) { lastT = ts; thumb.style.transform = ts; }
  }
  function queue() { if (!queued) queued = requestAnimationFrame(update); }
  // Lenis (below) scrolls from inside its own rAF: update right there, in the same frame
  window.__bbThumb = function() { if (queued) { cancelAnimationFrame(queued); } update(); };
  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', function() { docH = 0; queue(); }, { passive: true });
  if (window.ResizeObserver && document.body) {
    new ResizeObserver(function() { docH = 0; queue(); }).observe(document.body);
  } else {
    window.addEventListener('load', function() { docH = 0; queue(); });
  }
  update();
})();

// ── Cursor: visitors keep their own system cursor (the optional custom arrow is at the end of this file, off by default) ──

// ── In-page anchor links: smooth scroll with header offset (Lenis when present, native otherwise) ──
document.addEventListener('click', function(e) {
  if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
  var link = e.target.closest && e.target.closest('a[href^="#"]');
  if (!link) return;
  var href = link.getAttribute('href');
  if (!href || href.length < 2) return;
  var target = null;
  try { target = document.querySelector(href); } catch (err) { target = null; }
  if (!target) return; // native fallback
  e.preventDefault();
  if (window.__bbLenis) { window.__bbLenis.scrollTo(target, { offset: -90 }); return; }
  var top = target.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop) - 90;
  var rm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  try { window.scrollTo({ top: Math.max(0, top), behavior: rm ? 'instant' : 'smooth' }); } catch (err2) { window.scrollTo(0, Math.max(0, top)); }
});

// ── Lenis Smooth Scroll (desktop / fine pointer only, loaded on demand) ──
// Touch scrolling stays native on phones anyway (syncTouch:false), so phones skip the Lenis
// download and its per-frame loop entirely. On desktop the script loads async and never blocks the parser.
(function() {
  var mm = window.matchMedia;
  var reduced = mm && mm('(prefers-reduced-motion: reduce)').matches;
  var fine = mm && mm('(hover: hover) and (pointer: fine)').matches;
  if (reduced || !fine || window.__bbLenis) return;

  function init() {
    if (!window.Lenis || window.__bbLenis) return;

    var lenis = new window.Lenis({
      lerp: 0.1,
      smoothWheel: true,
      syncTouch: false, // keep touch scrolling native
      prevent: function(node) {
        return !!(node.closest && node.closest('[data-lenis-prevent],.afxh-desc-modal,#cart-drawer'));
      }
    });
    window.__bbLenis = lenis;

    function raf(t) { lenis.raf(t); requestAnimationFrame(raf); }
    requestAnimationFrame(raf);

    // keep the custom scrollbar thumb in sync with lenis-driven scroll (same cached-height updater as above)
    if (window.__bbThumb) lenis.on('scroll', window.__bbThumb);

    // pause smooth scroll while a modal / the cart drawer locks body scroll
    var mo = new MutationObserver(function() {
      if (document.body.style.overflow === 'hidden') lenis.stop();
      else lenis.start();
    });
    mo.observe(document.body, { attributes: true, attributeFilter: ['style'] });
    if (document.body.style.overflow === 'hidden') lenis.stop();
    // in-page anchor links reach lenis through window.__bbLenis (global anchor handler above)
  }

  if (window.Lenis) { init(); return; }
  var s = document.createElement('script');
  s.src = 'https://cdn.jsdelivr.net/npm/lenis@1.3.11/dist/lenis.min.js';
  s.async = true;
  s.onload = init;
  (document.head || document.documentElement).appendChild(s);
})();

// ── Universal Scroll Reveal ──
(function() {
  var html = document.documentElement;
  if (html.classList.contains('rvl-js')) return;
  // no IntersectionObserver (very old WebViews): never enter the hidden state, everything stays visible
  if (!('IntersectionObserver' in window)) return;
  html.classList.add('rvl-js');

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // phones / touch screens get no brand loader, so the page may already be painted when this runs:
  // whatever is on screen at boot stays as it is (no visible-hidden-fade flash, no staggered wait
  // before the price and the buy buttons). Content further down still reveals on scroll.
  var instantBoot = !!(window.matchMedia && window.matchMedia('(max-width: 749px), (hover: none)').matches);

  // legacy auto-tag targets (old blur-reveal list) + section children + page grids
  var LEGACY = '.product-card,.faq-item,.pol-card,.related-card,.gal-item,.ci-card,.resp-card,.topics-box,.blur-reveal,.bundle-item-card,.pack-gal-item,.section-title,.kicker,.compare-slider,.savings-grid,.savings-breakdown,.savings-highlight,.prod-section';
  var AUTO = LEGACY + ',.prod-section > *,.product-grid > *,.contact-grid > *,.faq-grid > *,.page-wrap > .pol-card';
  var EXCLUDE = '.afxh-sticky,.sticky-bar,#cart-drawer,.email-popup,header,.header-stack,.pill-nav-container,.page-transition-overlay';

  // ancestor already tagged, or already revealed / shown: its block animates (or animated) as one piece.
  // (a later scan, e.g. at window load, used to re-tag the children of a finished block and fade them in a second time)
  // Attribute reads only: safe to call between DOM writes, never forces a layout.
  function ancestorFree(el) {
    for (var p = el.parentElement; p; p = p.parentElement) {
      if (p.__rvlDone || (p.hasAttribute && p.hasAttribute('data-reveal'))) return false;
    }
    return true;
  }
  // Reads only (computed style, size). scan() runs this for every candidate BEFORE tagging any of them,
  // so the whole pass costs one style/layout instead of one per element (tag, measure, tag, measure...).
  function eligible(el) {
    if (el.nodeType !== 1) return false;
    if (el.__rvlDone || el.hasAttribute('data-reveal') || el.hasAttribute('data-afx-reveal')) return false;
    if (!el.closest) return false;
    if (el.closest(EXCLUDE)) return false;
    if (el.closest('[data-afx-reveal]')) return false; // never touch the AppleFX private system
    if (!ancestorFree(el)) return false;
    var cs = window.getComputedStyle(el);
    if (cs.position === 'fixed' || cs.position === 'sticky') return false;
    if (cs.display === 'none') return false;
    if (el.offsetHeight > window.innerHeight * 1.5) return false;
    return true;
  }

  function reveal(el, batchIndex) {
    if (el.__rvlDone) return;
    el.__rvlDone = true;
    obs.unobserve(el);
    var attrDelay = parseInt(el.getAttribute('data-reveal-delay') || '0', 10);
    if (isNaN(attrDelay) || attrDelay < 0) attrDelay = 0;
    var delay = Math.min(attrDelay, 8) * 70 + Math.min((batchIndex || 0) * 70, 400);
    if (delay > 0) el.style.transitionDelay = delay + 'ms';

    function done(e) {
      if (e && (e.target !== el || e.propertyName !== 'opacity')) return;
      el.removeEventListener('transitionend', done);
      clearTimeout(fallback);
      // clear inline delay + reveal attributes so no blurred/composited layers linger
      el.style.transitionDelay = '';
      el.classList.remove('rvl-in');
      el.removeAttribute('data-reveal');
    }
    var fallback = setTimeout(done, delay + 1100);
    el.addEventListener('transitionend', done);
    requestAnimationFrame(function() { el.classList.add('rvl-in'); });
  }

  var obs = new IntersectionObserver(function(entries) {
    var batch = 0;
    entries.forEach(function(entry) {
      if (entry.isIntersecting) { reveal(entry.target, batch); batch++; }
    });
  }, { threshold: 0.06, rootMargin: '0px 0px -40px 0px' });

  function scan(root, showInView) {
    root = root || document;
    if (!root.querySelectorAll) return;
    // auto-tag legacy / structural elements: measure all first, then tag in document order
    // (the ancestor check is repeated at tag time, so a block tagged in this pass still keeps its children untagged)
    var candidates = root.querySelectorAll(AUTO), ok = [];
    for (var i = 0; i < candidates.length; i++) ok.push(eligible(candidates[i]));
    for (var i2 = 0; i2 < candidates.length; i2++) {
      if (ok[i2] && ancestorFree(candidates[i2])) candidates[i2].setAttribute('data-reveal', '');
    }
    // observe every untracked [data-reveal]
    var targets = root.querySelectorAll('[data-reveal]');
    var vh = window.innerHeight || 800, inView = [];
    for (var j = 0; j < targets.length; j++) {
      var el = targets[j];
      if (el.__rvlObs || el.__rvlDone) continue;
      el.__rvlObs = true;
      if (reduced) { el.__rvlDone = true; el.removeAttribute('data-reveal'); continue; }
      if (showInView) {
        var r0 = el.getBoundingClientRect();
        if ((r0.width || r0.height) && r0.bottom > 0 && r0.top < vh) { el.__rvlDone = true; inView.push(el); continue; }
      }
      obs.observe(el);
    }
    // measured first, un-hidden after (no layout thrash); same task, so these never paint hidden
    for (var q = 0; q < inView.length; q++) inView[q].removeAttribute('data-reveal');
    // reveal above-the-fold elements quickly on load
    if (!reduced) {
      requestAnimationFrame(function() {
        var pending = document.querySelectorAll('[data-reveal]');
        var vis = [], vh2 = window.innerHeight;
        // rects first, reveals (style writes) after
        for (var k = 0; k < pending.length; k++) {
          if (pending[k].__rvlDone) continue;
          var r = pending[k].getBoundingClientRect();
          if (r.top < vh2 && r.bottom > 0) vis.push(pending[k]);
        }
        for (var b = 0; b < vis.length; b++) reveal(vis[b], b);
      });
    }
  }

  function boot() { scan(document, instantBoot); }
  // scan as soon as the markup is parsed (bbReady), not at DOMContentLoaded (which also waits for every
  // deferred app script): with no loader on phones, above-the-fold [data-reveal] content would otherwise
  // show, drop to hidden when html.rvl-js lands, and only fade back in once those scripts arrive.
  bbReady(boot);
  window.addEventListener('load', function() { scan(document); });
  document.addEventListener('shopify:section:load', function(e) { scan(e.target || document); });
})();

// ── Accordions ──
bbReady(function() {
  document.querySelectorAll('.faq-item').forEach(function(item) {
    item.addEventListener('click', function() {
      var open = item.classList.contains('open');
      item.parentElement.querySelectorAll('.faq-item').forEach(function(i) { i.classList.remove('open'); });
      if (!open) item.classList.add('open');
    });
  });
  document.querySelectorAll('.pol-card').forEach(function(block) {
    block.addEventListener('click', function(e) {
      if (e.target.closest('a')) return;
      var open = block.classList.contains('open');
      document.querySelectorAll('.pol-card').forEach(function(b) { b.classList.remove('open'); });
      if (!open) block.classList.add('open');
    });
  });
});

// ══════════════════════════════════════
// PILL NAV (sliding dot + hide on scroll)
// ══════════════════════════════════════
bbReady(function() {
  var container = document.querySelector('.pill-nav-container');
  var list = document.querySelector('.pill-list');
  var pills = [].slice.call(document.querySelectorAll('.pill'));

  // sliding indicator dot
  if (list && pills.length) {
    var dot = document.createElement('span');
    dot.className = 'pill-dot';
    list.appendChild(dot);
    var moveTimer;

    function centerOf(el) {
      var r = el.getBoundingClientRect(), lr = list.getBoundingClientRect();
      return r.left - lr.left + r.width / 2;
    }
    function moveTo(el, instant) {
      if (!el) { dot.classList.remove('show'); return; }
      var x = centerOf(el);
      if (instant) {
        var prev = dot.style.transition; dot.style.transition = 'none';
        dot.style.transform = 'translateX(-50%) translateX(' + x + 'px)';
        dot.classList.add('show');
        void dot.offsetWidth; dot.style.transition = prev;
        return;
      }
      dot.classList.add('show', 'moving');
      dot.style.transform = 'translateX(-50%) translateX(' + x + 'px)';
      clearTimeout(moveTimer);
      moveTimer = setTimeout(function() { dot.classList.remove('moving'); }, 420);
    }
    function activeEl() { return document.querySelector('.pill.is-active'); }

    moveTo(activeEl(), true);
    window.addEventListener('load', function() { moveTo(activeEl(), true); });
    if (document.fonts) document.fonts.ready.then(function() { moveTo(activeEl(), true); });

    pills.forEach(function(p) {
      p.addEventListener('mouseenter', function() { moveTo(p); });
    });
    list.addEventListener('mouseleave', function() { moveTo(activeEl()); });
    window.addEventListener('resize', function() { moveTo(activeEl(), true); });
  }

  // logo hover spin (CSS handles scale)
  // header stays pinned (no hide-on-scroll)

  // mobile burger (vanilla, no GSAP dependency)
  var burger = document.getElementById('mobile-burger'), pop = document.getElementById('mobile-popover'), mo = false;
  if (burger && pop) {
    pop.style.visibility = 'hidden'; pop.style.opacity = '0'; pop.style.transition = 'opacity .3s ease, transform .3s ease';
    burger.addEventListener('click', function() {
      mo = !mo;
      var lines = burger.querySelectorAll('.hamburger-line');
      if (mo) {
        if (lines[0]) { lines[0].style.transform = 'rotate(45deg) translateY(3px)'; }
        if (lines[1]) { lines[1].style.transform = 'rotate(-45deg) translateY(-3px)'; }
        pop.style.visibility = 'visible'; pop.style.opacity = '1'; pop.style.transform = 'translateY(0)';
      } else {
        if (lines[0]) { lines[0].style.transform = 'none'; }
        if (lines[1]) { lines[1].style.transform = 'none'; }
        pop.style.opacity = '0'; pop.style.transform = 'translateY(10px)';
        setTimeout(function() { if (!mo) pop.style.visibility = 'hidden'; }, 300);
      }
    });
  }
});

// ══════════════════════════════════════
// TEXT PRESSURE
// ══════════════════════════════════════
bbReady(function() {
  var els = document.querySelectorAll('[data-text-pressure]');
  if (!els.length) return;
  var m = { x: innerWidth/2, y: innerHeight/2 }, c = { x: m.x, y: m.y };
  addEventListener('mousemove', function(e) { c.x = e.clientX; c.y = e.clientY; }, { passive: true });

  els.forEach(function(el) {
    var t = el.dataset.textPressure || el.textContent, col = el.dataset.textColor || '#a8ff3e';
    el.textContent = ''; el.style.fontFamily = "'Compressa VF',sans-serif"; el.style.textTransform = 'uppercase';
    el.style.fontWeight = '100'; el.style.whiteSpace = 'nowrap'; el.style.userSelect = 'none';
    el.style.display = 'inline-flex'; el.style.color = col;
    var spans = [];
    for (var i = 0; i < t.length; i++) { var s = document.createElement('span'); s.textContent = t[i]; s.style.display = 'inline-block'; el.appendChild(s); spans.push(s); }
    el._s = spans;
  });

  function dist(a,b){return Math.sqrt((b.x-a.x)**2+(b.y-a.y)**2)}
  function ga(d,mx,mn,mx2){return Math.max(mn,mx2-Math.abs(mx2*d/mx)+mn)}
  // run the per-frame loop only while a pressure heading is on screen and the tab is visible
  var onScreen=els.length, running=false;
  function anim(){
    if(!onScreen||document.hidden){running=false;return;}
    m.x+=(c.x-m.x)/12; m.y+=(c.y-m.y)/12;
    // every letter is measured first and written after: one layout per frame instead of one per letter
    var todo=[];
    els.forEach(function(el){
      var r=el.getBoundingClientRect(),md=r.width/2;
      el._s.forEach(function(s){
        var sr=s.getBoundingClientRect(),d=dist(m,{x:sr.x+sr.width/2,y:sr.y+sr.height/2});
        var v="'wght' "+Math.floor(ga(d,md,100,900))+",'wdth' "+Math.floor(ga(d,md,5,200))+",'ital' "+ga(d,md,0,1).toFixed(2);
        if(s._fv!==v)todo.push(s,v);
      });
    });
    for(var q=0;q<todo.length;q+=2){todo[q]._fv=todo[q+1];todo[q].style.fontVariationSettings=todo[q+1];}
    requestAnimationFrame(anim);
  }
  function kick(){if(!running&&onScreen&&!document.hidden){running=true;requestAnimationFrame(anim);}}
  if('IntersectionObserver' in window){
    var vis=new Map();
    var tio=new IntersectionObserver(function(es){
      es.forEach(function(e){vis.set(e.target,e.isIntersecting);});
      onScreen=0;vis.forEach(function(v){if(v)onScreen++;});
      kick();
    });
    els.forEach(function(el){vis.set(el,true);tio.observe(el);});
  }
  document.addEventListener('visibilitychange',kick);
  kick();
});

// ══════════════════════════════════════
// LINEWAVES · replaced by Aurora Shader in home-hero.liquid
// ══════════════════════════════════════

// ══════════════════════════════════════
// PAGE TRANSITIONS · a 2px lime progress bar, nothing else
// Never blocks or delays navigation (no preventDefault, no full-screen loader): it only shows
// that the tap registered while the next page loads. Skips checkout/cart, external links, anchors,
// new tabs, modifier clicks and downloads.
// ══════════════════════════════════════
(function() {
  if (window.__bbNavBar) return; window.__bbNavBar = 1;
  var bar = null, capT = 0, resetT = 0, anim = null;
  var SKIP_PATH = /(^|\/)(cart|checkout|checkouts)(\/|$)/;

  function ensure() {
    if (bar) return bar;
    bar = document.createElement('div');
    bar.id = 'bb-navbar';
    bar.setAttribute('aria-hidden', 'true');
    bar.style.cssText = 'position:fixed;left:0;top:0;width:100%;height:2px;z-index:2147483601;pointer-events:none;background:#a8ff3e;box-shadow:0 0 10px rgba(168,255,62,.55);transform-origin:0 50%;transform:scaleX(0);opacity:0';
    document.body.appendChild(bar);
    return bar;
  }
  function start() {
    var b = ensure();
    clearTimeout(capT); clearTimeout(resetT);
    if (b.animate) {
      // Web Animations: the same 7s grow, started without a forced reflow inside the click handler
      // (the old "void offsetWidth" restart made every internal link tap pay for a synchronous layout)
      if (anim) anim.cancel();
      b.style.transition = 'none';
      b.style.opacity = '1';
      anim = b.animate([{ transform: 'scaleX(0)' }, { transform: 'scaleX(.92)' }], { duration: 7000, easing: 'cubic-bezier(.08,.82,.17,1)', fill: 'forwards' });
    } else {
      b.style.transition = 'none';
      b.style.transform = 'scaleX(0)';
      b.style.opacity = '1';
      void b.offsetWidth;
      b.style.transition = 'transform 7s cubic-bezier(.08,.82,.17,1),opacity .2s ease';
      b.style.transform = 'scaleX(.92)';
    }
    capT = setTimeout(reset, 12000); // navigation never happened (204, download, cancelled): fade out
  }
  function reset() {
    if (!bar) return;
    clearTimeout(capT);
    bar.style.transition = anim ? 'opacity .2s ease' : bar.style.transition;
    bar.style.opacity = '0';
    resetT = setTimeout(function() {
      if (anim) { anim.cancel(); anim = null; }
      if (bar) { bar.style.transition = 'none'; bar.style.transform = 'scaleX(0)'; }
    }, 250);
  }

  // window-level bubble listener runs after every element/document handler, so defaultPrevented is final
  window.addEventListener('click', function(e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var link = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!link || link.hasAttribute('download') || link.hasAttribute('data-no-progress')) return;
    var tgt = (link.getAttribute('target') || '').toLowerCase();
    if (tgt && tgt !== '_self') return;
    var raw = link.getAttribute('href') || '';
    if (!raw || raw.charAt(0) === '#') return;
    var u;
    try { u = new URL(raw, window.location.href); } catch (err) { return; }
    if (u.protocol !== 'http:' && u.protocol !== 'https:') return;   // mailto:, tel:, javascript:
    if (u.origin !== window.location.origin) return;                  // external
    if (SKIP_PATH.test(u.pathname)) return;                            // /cart, /cart/..., /checkout(s)
    if (u.pathname === window.location.pathname && u.search === window.location.search) return; // same page / anchor
    start();
  });
  // back/forward cache restore: the old page comes back with the bar mid-way, clear it
  window.addEventListener('pageshow', function(e) { if (e.persisted) reset(); });
})();

// ── Policy Accordion ──
document.addEventListener('click', function(e) {
  var hdr = e.target.closest('.pol-hdr');
  if (!hdr) return;
  var card = hdr.closest('.pol-card');
  if (!card) return;
  var isOpen = card.classList.contains('open');
  document.querySelectorAll('.pol-card').forEach(function(b) { b.classList.remove('open'); });
  if (!isOpen) card.classList.add('open');
});

// ── Collapsible product description ──
(function() {
  document.querySelectorAll('.desc-toggle').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var acc = btn.closest('.desc-accordion');
      var body = acc.querySelector('.desc-body');
      var open = acc.classList.toggle('open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      body.style.maxHeight = open ? (body.scrollHeight + 'px') : null;
    });
  });
})();

// ── Evergreen urgency timers · [data-urg-timer] ──
(function(){
  function fmt(sec,mode){
    if(mode==='dhms'){
      var d=Math.floor(sec/86400),h=Math.floor(sec%86400/3600),mi=Math.floor(sec%3600/60),ss=sec%60;
      return d+'d '+(h<10?'0':'')+h+':'+(mi<10?'0':'')+mi+':'+(ss<10?'0':'')+ss;
    }
    var m=Math.floor(sec/60),s=sec%60;return (m<10?'0':'')+m+':'+(s<10?'0':'')+s;
  }
  // Same timers, same numbers, same storage. Per second only the digits that actually changed are written
  // (the days/hours/minutes cells used to be re-rendered every second too), and nothing runs while the tab is hidden.
  function put(n,v){if(n&&n.__urgV!==v){n.__urgV=v;n.textContent=v;}}
  function init(){
    if(window.__bbUrg)return;window.__bbUrg=1;
    var els=[].slice.call(document.querySelectorAll('[data-urg-timer]'));
    if(!els.length)return;
    function tick(){
      if(document.hidden)return;
      var now=Date.now();
      els.forEach(function(el){
        var mins=parseInt(el.getAttribute('data-urg-minutes'),10)||15;
        var key='bbUrg:'+(el.getAttribute('data-urg-key')||'sale');
        var end=0;
        try{end=parseInt(localStorage.getItem(key),10)||0;}catch(e){}
        if(!end||end<=now){end=now+mins*60000;try{localStorage.setItem(key,end);}catch(e){}}
        var left=Math.max(0,Math.round((end-now)/1000));
        var mode=el.getAttribute('data-urg-format');
        if(mode==='cells'){
          var cd=Math.floor(left/86400),ch=Math.floor(left%86400/3600),cm=Math.floor(left%3600/60),cs2=left%60;
          var p2=function(n){return (n<10?'0':'')+n;};
          if(!el.__urgC)el.__urgC=[el.querySelector('[data-ud]'),el.querySelector('[data-uh]'),el.querySelector('[data-um]'),el.querySelector('[data-us]')];
          put(el.__urgC[0],p2(cd));
          put(el.__urgC[1],p2(ch));
          put(el.__urgC[2],p2(cm));
          put(el.__urgC[3],p2(cs2));
        }else{
          put(el,fmt(left,mode));
        }
        if(el.__urgW===undefined)el.__urgW=el.closest('.announce-timer,.d-urgency');
        if(el.__urgW){el.__urgW.classList.toggle('urg-low',left<300);}
      });
    }
    tick();
    setInterval(tick,1000);
    document.addEventListener('visibilitychange',function(){if(!document.hidden)tick();});
  }
  /* every timer (header, AppleFX hero, cart drawer) is parsed before this end-of-body script: start now, so the cells never sit on "--" while deferred app scripts hold DOMContentLoaded */
  bbReady(init);
})();

// ── Motion layer · split-text reveals, parallax, tilt ──
(function(){
  var RM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function splitInit(){
    document.querySelectorAll('[data-split]').forEach(function(el){
      if(el.__split) return; el.__split = 1;
      var nodes = [].slice.call(el.childNodes), i = 0;
      nodes.forEach(function(n){
        if(n.nodeType === 3){
          var frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach(function(part){
            if(!part) return;
            if(/^\s+$/.test(part)){ frag.appendChild(document.createTextNode(' ')); return; }
            var w = document.createElement('span'); w.className = 'sw'; w.style.setProperty('--i', i++); w.textContent = part; frag.appendChild(w);
          });
          el.replaceChild(frag, n);
        } else if(n.nodeType === 1){
          n.classList.add('sw'); n.style.setProperty('--i', i++);
        }
      });
      el.classList.add('split-ready');
    });
    if(RM){ document.querySelectorAll('[data-split]').forEach(function(el){ el.classList.add('split-in'); }); return; }
    if(!('IntersectionObserver' in window)){ document.querySelectorAll('[data-split]').forEach(function(el){ el.classList.add('split-in'); }); return; }
    var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('split-in'); io.unobserve(e.target); } }); }, { threshold: .2 });
    document.querySelectorAll('[data-split]').forEach(function(el){ io.observe(el); });
  }
  function parallaxInit(){
    if(RM) return;
    var els = [].slice.call(document.querySelectorAll('[data-parallax]'));
    if(!els.length) return;
    var ticking = false;
    function update(){
      ticking = false;
      var vh = window.innerHeight || 800, out = [];
      // all rects first, then the transforms (no measure/write/measure thrash)
      els.forEach(function(el){
        var r = el.getBoundingClientRect(); if(r.bottom < -200 || r.top > vh + 200) return;
        var k = parseFloat(el.getAttribute('data-parallax')) || .15;
        var d = (r.top + r.height / 2 - vh / 2) * k;
        out.push(el, 'translate3d(0,' + d.toFixed(1) + 'px,0)');
      });
      for(var i = 0; i < out.length; i += 2) out[i].style.transform = out[i + 1];
    }
    window.addEventListener('scroll', function(){ if(!ticking){ ticking = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', update, { passive: true }); update();
  }
  function tiltInit(){
    if(RM || (window.matchMedia && matchMedia('(hover: none)').matches)) return;
    document.querySelectorAll('[data-tilt-card]').forEach(function(c){
      if(c.__tilt) return; c.__tilt = 1;
      c.addEventListener('pointermove', function(e){
        var r = c.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
        c.style.setProperty('--tx', ((y - .5) * -6).toFixed(2) + 'deg');
        c.style.setProperty('--ty', ((x - .5) * 8).toFixed(2) + 'deg');
        c.style.setProperty('--gx', (x * 100).toFixed(1) + '%');
        c.style.setProperty('--gy', (y * 100).toFixed(1) + '%');
        c.classList.add('tilt-on');
      });
      c.addEventListener('pointerleave', function(){ c.classList.remove('tilt-on'); c.style.setProperty('--tx', '0deg'); c.style.setProperty('--ty', '0deg'); });
    });
  }
  function boot(){ splitInit(); parallaxInit(); tiltInit(); }
  bbReady(boot);
  document.addEventListener('shopify:section:load', boot);
})();

// ── Optional custom cursor (desktop, fine pointers only) ──
// Off by default: runs only when Theme settings > Cursor > Custom cursor is on (layout/theme.liquid then sets
// <html data-bb-cursor> and ships the cursor CSS). Otherwise it returns here and adds no listeners.
(function(){
  if(window.__bbCursor)return;window.__bbCursor=1;
  if(!document.documentElement.hasAttribute('data-bb-cursor'))return;
  if(window.Shopify&&Shopify.designMode)return;
  if(!(window.matchMedia&&matchMedia('(hover: hover) and (pointer: fine)').matches))return;
  function init(){
    if(document.getElementById('bb-cursor')||!document.body)return;
    /* starts hidden: until the first mousemove we do not know where the pointer is (it used to sit at the top-left corner) */
    var c=document.createElement('div');c.id='bb-cursor';c.className='bb-cur-hide';c.setAttribute('aria-hidden','true');
    /* the owner's cursor: chunky rounded black pointer (rounding via thick same-color stroke), thin white rim for dark sections */
    var P='M2.6 2.6 L29.8 12.4 L18 17.6 L12.6 29.6 Z';
    c.innerHTML='<svg viewBox="0 0 32 32" width="28" height="28">'
      +'<path d="'+P+'" fill="#fff" stroke="#fff" stroke-width="6.4" stroke-linejoin="round"/>'
      +'<path d="'+P+'" fill="#0b0b0c" stroke="#0b0b0c" stroke-width="3.6" stroke-linejoin="round"/>'
      +'</svg>';
    document.body.appendChild(c);
    /* the system cursor is hidden (html.bb-cur) only once the custom one knows where to draw: no cursor-less moment after a page load.
       Position: the latest mouse point is kept and drawn once per frame (rAF), all listeners passive. */
    var cx=0,cy=0,cq=0,hid=true;
    function draw(){cq=0;c.style.transform='translate3d('+cx+'px,'+cy+'px,0)';if(hid){hid=false;c.classList.remove('bb-cur-hide');}if(!c.__on){c.__on=1;document.documentElement.classList.add('bb-cur');}}
    document.addEventListener('mousemove',function(e){cx=e.clientX;cy=e.clientY;if(!cq)cq=requestAnimationFrame(draw);},{passive:true});
    /* a draw still queued from the last move must not bring the cursor back after the pointer left the window */
    document.documentElement.addEventListener('mouseleave',function(){if(cq){cancelAnimationFrame(cq);cq=0;}hid=true;c.classList.add('bb-cur-hide');},{passive:true});
    var lastLink=null;
    document.addEventListener('mouseover',function(e){
      var t=e.target&&e.target.closest?e.target.closest('a,button,[onclick],input,select,textarea,summary,label,[role="button"],.afxd-row,.afxd-tab'):null;
      if(!!t!==lastLink){lastLink=!!t;c.classList.toggle('bb-cur-link',lastLink);}
    },{passive:true});
    document.addEventListener('mousedown',function(){c.classList.add('bb-cur-down');},{passive:true});
    document.addEventListener('mouseup',function(){c.classList.remove('bb-cur-down');},{passive:true});
  }
  bbReady(init);
})();

// ── Brand loader (first desktop view only, layout/theme.liquid): the page is parsed and wired up by now, fade it out ──
if (window.__bbLdHide) { try { window.__bbLdHide(); } catch (e) {} }
